export const SCENE = 'SCENE';
export const CAMERA = 'CAMERA';
export const RENDERER = 'RENDERER';
export const PMREMGENERATOR = 'PMREMGENERATOR';
export const ENV_MAP = 'ENV_MAP';
export const LOADED_TOTAL = 'LOADED_TOTAL';
export const LOADED_ITEMS = 'LOADED_ITEMS';
export const LOAD_FINISHED = 'LOAD_FINISHED';
export const LOADING_MANAGER = 'LOADING_MANAGER';
export const CONTROLS = 'CONTROLS';
export const HOTSPOTS = 'HOTSPOTS';
export const HOTSPOT_OFF_TEXTURE = 'HOTSPOT_OFF_TEXTURE';
export const HOTSPOT_ON_TEXTURE = 'HOTSPOT_ON_TEXTURE';
